<template>
    <modal :title="$t(Dtitle)" :visible.sync="isShowDialog" width="600px">
        <div class="content">
            <div class="icon">
                <i class="el-icon-edit" @click="changeBoolFn" v-if="isEdit && detailObj.sign !== 1"></i>
                <i class="el-icon-back" style="color:var(--primary-color);" v-if="!isEdit" @click="changeBoolFn"></i>
            </div>
            <el-form ref="form" :model="dioForm" :rules="!isEdit ? rules : noRules" label-width="160px">

                <el-form-item :label="$t('public.table_scope')" prop="sceneId" v-if="$store.state.type === 3 || $store.state.type === 2">
                    <el-select v-model="dioForm.sceneId" style="width: 250px" v-if="!isEdit">
                        <el-option v-for="item in customerArray" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                    <span v-else>{{ textChange(detailObj['sceneId']) }}</span>

                </el-form-item>
                <el-form-item :label="$t('integration.name')" prop="name" v-if="!isEdit">
                    <el-input v-model.trim="dioForm.name" style="width: 250px" :placeholder="$t('integration.please_enter_a_name')" />

                </el-form-item>
                <el-form-item :label="$t('public.phone_num')" prop="phone">
                    <el-input v-if="!isEdit" v-model.trim="dioForm.phone" style="width: 250px" :placeholder="$t('integration.please_enter_your_mobile_number')" />
                    <span v-else>{{ detailObj['phone'] }}</span>

                </el-form-item>
                <el-form-item :label="$t('public.emailbox')" prop="email">
                    <el-input v-if="!isEdit" v-model.trim="dioForm.email" style="width: 250px" :placeholder="$t('integration.please_enter_email_address')" />
                    <span v-else>{{ detailObj['email'] }}</span>
                </el-form-item>
                <!--<el-form-item :label="$t('public.wechat')" prop="we_chat">-->
                <!--    <el-input v-if="!isEdit" v-model.trim="dioForm.we_chat" style="width: 250px" :placeholder="$t('integration.please_enter_wechat')" />-->
                <!--    <span v-else>{{ detailObj['we_chat'] }}</span>-->
                <!--</el-form-item>-->
                <!--<el-form-item :label="$t('QQ')" prop="qq">-->
                <!--    <el-input v-if="!isEdit" v-model.trim="dioForm.qq" style="width: 250px" :placeholder="$t('public.please_enter')" />-->
                <!--    <span v-else>{{ detailObj['qq'] }}</span>-->
                <!--</el-form-item>-->
                <!--<el-form-item :label="$t('MSN')" prop="msn">-->
                <!--    <el-input v-if="!isEdit" v-model.trim="dioForm.msn" style="width: 250px" :placeholder="$t('integration.please_enter_an_msn')" />-->
                <!--    <span v-else>{{ detailObj['msn'] }}</span>-->
                <!--</el-form-item>-->
                <!--<el-form-item :label="$t('Skype')" prop="skype">-->
                <!--    <el-input v-if="!isEdit" v-model.trim="dioForm.skype" style="width: 250px" :placeholder="$t('integration.please_enter_skype')" />-->
                <!--    <span v-else>{{ detailObj['skype'] }}</span>-->
                <!--</el-form-item>-->
                <!--<el-form-item :label="$t('public.blog')" prop="micro_blog">-->
                <!--    <el-input v-if="!isEdit" v-model.trim="dioForm.micro_blog" style="width: 250px"-->
                <!--        :placeholder="$t('integration.please_enter_weibo')" />-->
                <!--    <span v-else>{{ detailObj['micro_blog'] }}</span>-->
                <!--</el-form-item>-->


            </el-form>
        </div>

        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
            <el-button type="primary" v-if="!isEdit" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
        </div>
    </modal>
</template>

<script>
import { contactsUpdate } from '@/api/modules/contact.js';
export default {
    props: ['isShow', 'title', 'detailObj', 'customerArray'],
    watch: {
        detailObj(newVaL) {
            const { name, phone, email, weChat, qq, msn, skype, microBlog, id, sceneId } = { ...newVaL };
            this.dioForm = {
                sceneId: String(sceneId),
                name,
                phone,
                email,
                weChat,
                qq,
                msn,
                skype,
                microBlog, id
            }
        },
        title(newVal) {
            this.Dtitle = newVal
        }
    },
    computed: {
        scopeIdSuer() {
            return this.$store.getters.userInfo.scope.sceneId
        },
        isShowDialog: {
            get: function () {
                return this.isShow
            },
            set: function (val) {
                this.$emit('update:isShow', val);//可以优化成model  或者minx
            }
        },
        isSysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            return currentUser.sysScope && currentUser.sysAdmin || currentUser.sysScope && !currentUser.sysAdmin
        },
        noRules() {
            return {

            }
        },
        rules() {
            let numberFn = (rules, value, callback) => {
                let reg = /^[1-9][0-9]{4,10}$/;
                if (!reg.test(value) && value) {
                    callback($t('integration.qq_format_is_incorrect'))
                } else {
                    callback()
                }
            }
            return {
                sceneId: [{ required: true, message: $t('integration.customer_cannot_be_empty'), trigger: 'change' }],
                name: [{ required: true, message: $t('integration.name_cannot_be_empty'), trigger: 'blur' },
                {
                    max: 50,
                    trigger: 'blur',
                    message: $t('integration.length_within_50')
                }
                ],
                phone: [{ required: true, message: $t('integration.mobile_number_cannot_be_empty'), trigger: 'blur' },
                {
                    max: 20,
                    trigger: 'blur',
                    message: $t('integration.length_within_20')
                },
                ],
                email: [{ required: true, message: $t('integration.mailbox_cannot_be_empty'), trigger: 'blur' },
                {
                    max: 255,
                    trigger: 'blur',
                    message: $t('integration.length_within_255')
                },
                { type: 'email', message: $t('integration.please_enter_the_correct_email_address'), trigger: ['blur', 'change'] }
                ],
                weChat: [
                    {
                        max: 100,
                        trigger: 'blur',
                        message: $t('integration.length_within_100'),
                        required: false
                    }
                ],
                qq: [
                    {
                        max: 20,
                        trigger: 'blur',
                        message: $t('integration.length_within_20'),
                        required: false
                    },
                    {
                        required: false,
                        validator: numberFn,
                        trigger: 'blur',
                    },
                ],
                msn: [
                    {
                        max: 255,
                        trigger: 'blur',
                        message: $t('integration.length_within_255'),
                        required: false
                    }
                ],
                skype: [
                    {
                        max: 255,
                        trigger: 'blur',
                        message: $t('integration.length_within_255'),
                        required: false
                    }
                ],
                microBlog: [
                    {
                        max: 255,
                        trigger: 'blur',
                        message: $t('integration.length_within_255'),
                        required: false
                    }
                ],

            }
        }
    },
    data() {
        return {
            Dtitle: '',
            isEdit: true,
            dioForm: {
                sceneId: '',
                name: '',
                phone: '',
                email: '',
                weChat: '',
                qq: '',
                msn: '',
                skype: '',
                microBlog: '',
                id: ''
            }
        }
    },
    methods: {
        textChange(curID) {
            let str = '';
            for (let item of this.customerArray) {
                if (item.id === String(curID)) {
                    str = item.name
                    break
                }
            }
            return str
        },
        changeBoolFn() {
            this.isEdit = !this.isEdit;
            this.Dtitle = this.isEdit ? `[${this.detailObj.name}] ${$t('public.contact_details')}` : `${$t('public.edit')} [${this.detailObj.name}]`;
            this.clearValidate();
        },
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.clearValidate();
            }
        },
        async justify() {
            try {
                return await this.$refs['form'].validate()
            }
            catch (error) {
                return false
            }
        },
        async handleSave() {
            let flag = await this.justify();
            if (!flag) return
            contactsUpdate(this.dioForm).then(({ result }) => {
                if (result === 400) {
                    this.$message.error($t('integration.fail'))
                } else if (result === 200) {
                    this.$message.success($t('integration.success'));
                    this.isShowDialog = false,
                        this.$parent.getListFn()
                } else if (result === 408) {
                    this.$message.error($t('integration.name_already_exists'))
                } else if (result === 409) {
                    this.$message.error($t('integration.mobile_number_already_exists'))
                }
                else if (result === 410) {
                    this.$message.error($t('integration.mailbox_already_exists'))
                }
                else {
                    this.$message.error(this.$t('public.unknown_error'));
                }
            })
        },

    }
}
</script>

<style lang="scss" scoped>
.content {
    .icon {
        text-align: right;
    }
}
</style>
